// src/i18n/translations/tr.js

export default {
  // Genel elementler ve eylemler
  common: {
    save: 'Kaydet',
    delete: 'Sil',
    edit: 'Düzenle',
    loading: 'Yükleniyor',
    success: 'Başarılı',
    error: 'Hata',
    confirm: 'Onayla',
    warning: 'Uyarı',
    info: 'Bilgi',
    close: 'Kapat',
    cancel: 'İptal',
    changeLanguage: 'Dil değiştir',
    changingLanguage: 'Dil değiştiriliyor...',
    languageInfoDescription: 'Dil değişiklikleri anında uygulanır ve tüm içeriğe yansır. Tercihiniz otomatik olarak kaydedilir.',
    quickAccess: 'Hızlı Erişim',
    closeMenu: 'Menüyü kapat',
    tools: 'Araçlar',
    me: 'Ben',
    add: 'Ekle',
    copy: 'Kopyala',
    copyLink: 'Bağlantıyı Kopyala',
    share: 'Paylaş',
    copyFailed: 'Kopyalama başarısız:',
    name: 'İsim',
    user: 'Kullanıcı',
    continue: 'Devam',
    processing: 'İşleniyor...',
    change: 'Değiştir',
    copied: 'Kopyalandı',
    understand: 'Anladım',
    ok: 'Tamam',
    back: 'Geri',
    logoAlt: 'IDapps Logo', // Eklendi
    version: 'IDapps v2.0.31', // Eklendi
    digitalDiscipline: 'Dijital Disiplin' // Added Digital Discipline translation
  },

  // Sloganlar - Dinamik slogan desteği için yeni eklendi
  slogan: {
    decentralized: "Dünya'nın ilk merkeziyetsiz kimlik çözümü",
    evolution: "Kimliğin evriminde bir sonraki adım",
    control: "Verilerinizin kontrolünü geri alın",
    secure: "Dijital kimliğinizin güvenli kalesi",
    realIdentity: "Gerçek kimliğinizi dijital dünyaya taşıyın",
    assets: "Tüm dijital varlıklarınız tek bir yerde",
    dataOwnership: "Kişisel verileriniz size aittir",
    future: "Merkeziyetsiz geleceğe hoş geldiniz",
    youBelong: "Sizi siz yapan şey size aittir",
    welcome: "IDapps'e hoş geldiniz"
  },

  // Navigasyon ve Menü öğeleri
  nav: {
    dashboard: 'Ana Sayfa',
    profile: 'Profil',
    digitalVault: 'Dijital Kasa',
    settings: 'Ayarlar',
    twoFA: 'İki Faktörlü Doğrulama',
    qrCode: 'QR Kod',
    securitySettings: 'Güvenlik Ayarları',
    notifications: 'Bildirimler',
    vault: 'Dijital Kasa',
    qr: 'QR',
    messages: 'Mesajlar',
    gameHub: 'Oyunlar',
    statistics: 'İstatistikler' // Added: Statistics navigation translation
  },

  // Karşılama ekranı
  welcome: {
    title: 'Dünyanın ilk merkeziyetsiz kimliği',
    subtitle: 'IDapps\'e katılarak sen de yeni dünyaya giriş yap',
    loginButton: 'Giriş yap',
    signupButton: 'Hesap oluştur',
    footer: {
      description: 'Merkeziyetsiz blockchain destekli kimlik platformu',
      version: 'v1.0.1 © 2023-2025 IDapps'
    },
    welcomeTitle: 'Hoş Geldiniz',
    headline: 'Dünyanın ilk merkeziyetsiz kimliği',
    heroTitle: 'Kimliğiniz,\nYeniden Tasarlandı.',
    getStarted: 'Başlayın',
    haveAccount: 'Zaten hesabınız var mı?',
    login: 'Giriş Yap',
    signInWithApple: 'Apple ile giriş yap',
    subtitle: 'Dijital kimliğinizin kontrolünü elinize alın',
    futureFeature: 'Yakında güvenli biyometrik kimlik doğrulama',
  },

  // Giriş ekranı ve kimlik doğrulama
  login: {
    title: 'Dünyanın ilk merkeziyetsiz kimliği',
    subtitle: 'IDapps\'e katılarak sen de yeni dünyaya giriş yap',
    usernameInput: 'Kullanıcı adı veya e-posta',
    formError: {
      emptyFields: 'Lütfen kullanıcı adı ve şifre girin.',
      default: 'Giriş yapılamadı. Lütfen kullanıcı adı ve şifrenizi kontrol edin.',
      demoFailed: 'Demo giriş yapılamadı.'
    },
    loggingIn: 'Giriş yapılıyor...',
    loginButton: 'Giriş yap',
    demoLoginDone: 'Demo Giriş Yapıldı',
    demoLogin: 'Demo Giriş (Geliştirici)',
    forgotPassword: 'Şifremi unuttum',
    noAccount: 'Henüz bir IDapps hesabın yok mu?',
    createAccount: 'Hesap oluştur',
    loginTitle: 'Giriş',
    welcomeBack: 'Tekrar Hoş Geldiniz',
    subtitle: 'Dijital kasanıza erişmek için giriş yapın',
    username: 'Kullanıcı adı',
    email: 'E-posta',
    password: 'Şifre',
    passwordPlaceholder: 'Şifrenizi giriniz',
    forgot: 'Şifremi Unuttum?',
    submit: 'Giriş Yap',
    processing: 'İşleniyor...',
    create: 'Kimlik Oluştur',
    error: {
      empty: 'Lütfen tüm alanları doldurun',
      failed: 'Giriş başarısız. Bilgilerinizi kontrol edin.'
    }
  },

  // Kayıt ekranı
  signup: {
    title: 'Dünyanın ilk merkeziyetsiz kimliği',
    subtitle: 'IDapps\'e katılarak sen de yeni dünyaya giriş yap',
    createIdappsAccount: 'IDapps hesabı oluştur',
    createAccountWithApple: 'APPLE İLE HESAP OLUŞTUR',
    createAccountWithFacebook: 'FACEBOOK İLE HESAP OLUŞTUR',
    alreadyHaveAccount: 'Zaten bir IDapps hesabınız var mı?',
    signupTitle: 'Kayıt Ol',
    confirmPassword: 'Şifreyi Onayla',
    phoneNumber: 'Telefon Numarası',
    verificationCode: 'Doğrulama Kodu',
    continueButton: 'Devam Et',
    createAccount: 'Hesap Oluştur',
    enterPhone: 'Telefon numaranızı girin',
    phonePlaceholder: 'Telefon numarası',
    invalidPhone: 'Geçersiz telefon numarası',
    createAccountWithVoice: 'Sesli Kayıt ile Hesap Oluştur',
    joinFuture: 'Geleceğe Katılın',
    subtitle: 'Merkeziyetsiz kimlik ağına katılın',
    name: 'Ad Soyad',
    email: 'E-posta Adresi',
    password: 'Şifre',
    submit: 'Hesap Oluştur',
    processing: 'Hesap Oluşturuluyor...',
    or: 'Veya şununla devam et',
    hasAccount: 'Zaten hesabınız var mı?',
    login: 'Giriş Yap',

    // Yeni Kayıt Akışı Anahtarları
    nameTitle: "Adınız nedir?",
    nameSubtitle: "Bu profilinizde görünecek",
    namePlaceholder: "Adınız Soyadınız",

    emailTitle: "E-postanız nedir?",
    emailSubtitle: "Hesap doğrulama için kullanacağız",
    emailPlaceholder: "ornek@mail.com",

    passwordTitle: "Bir şifre oluşturun",
    passwordSubtitle: "Güçlü ve benzersiz olsun",
    passwordPlaceholder: "En az 8 karakter",

    confirmTitle: "Bilgileri onayla",
    confirmSubtitle: "Her şeyin doğru olduğundan emin olun",

    complete: "Hesap Oluştur",

    haveAccount: "Zaten hesabınız var mı?",

    error: {
      nameRequired: "İsim gereklidir",
      emailRequired: "E-posta gereklidir",
      emailInvalid: "Geçersiz e-posta adresi",
      passwordLength: "Şifre en az 8 karakter olmalı",
      generic: "Kayıt başarısız. Lütfen tekrar deneyin.",
      empty: 'Lütfen tüm alanları doldurun',
      failed: 'Kayıt başarısız. Lütfen tekrar deneyin.'
    }
  },

  // VoiceSignupScreen için çeviriler
  voiceSignup: {
    title: 'IDapps Hesap Oluşturma',
    welcome: 'Hesap oluşturucuya hoş geldiniz',

    // Legacy keys kept for safety if used elsewhere, but values neutralized
    askName: 'Öncelikle ismini öğrenebilir miyim?',
    enterName: 'Lütfen adınızı girin',
    askEmail: 'E-posta adresini girin',
    enterEmail: 'Lütfen e-posta adresinizi girin',
    // Phone keys removed
    askPassword: 'Güvenli bir şifre belirleyin.',
    enterPassword: 'Lütfen güvenli bir şifre belirleyin',
    passwordTooShort: 'Şifre en az 8 karakter olmalı.',
    confirmVoice: 'Bilgilerinizi onaylayın.',
    confirmText: 'Bilgilerinizi onaylayın.',
    reviewInfo: 'Bilgileri gözden geçirelim.',
    successVoice: 'IDapps hesabınız başarıyla oluşturuldu.',
    successText: 'IDapps hesabınız başarıyla oluşturuldu.',
    errorVoice: 'Hesap oluşturulurken hata oluştu.',
    errorText: 'Hesap oluşturulurken hata oluştu.',
    listening: '',
    textModeAuto: 'Yazılı form kullanılacak.',
    textModeEnabled: 'Yazılı forma geçildi.',

    // New nested keys for VoiceSignupScreen (Refactored Signup)
    name: {
      title: 'Adınız nedir?',
      subtitle: 'Bu profilinizde görünecek',
      required: 'İsim gereklidir',
      tooShort: 'İsim en az 2 karakter olmalıdır',
      placeholder: 'Adınız'
    },
    email: {
      title: 'E-posta adresiniz nedir?',
      subtitle: 'Hesap doğrulama için kullanacağız',
      required: 'E-posta gereklidir',
      invalid: 'Geçersiz e-posta adresi',
      placeholder: 'eposta@ornek.com'
    },
    password: {
      title: 'Bir şifre oluşturun',
      subtitle: 'Güçlü ve benzersiz olsun',
      required: 'Şifre gereklidir',
      tooShort: 'Şifre en az 8 karakter olmalı',
      weak: 'Şifre büyük harf, küçük harf ve rakam içermeli',
      mismatch: 'Şifreler eşleşmiyor',
      placeholder: 'Şifre oluşturun',
      confirmPlaceholder: 'Şifrenizi onaylayın',
      requirement1: 'En az 8 karakter',
      requirement2: 'En az bir büyük harf',
      requirement3: 'En az bir küçük harf',
      requirement4: 'En az bir rakam'
    },
    confirm: {
      title: 'Bilgilerinizi onaylayın',
      subtitle: 'Her şeyin doğru olduğundan emin olun',
      createAccount: 'Hesap Oluştur'
    },
    completed: {
      title: 'Hesap oluşturuldu!',
      subtitle: 'Merkeziyetsiz geleceğe hoş geldiniz',
      message: 'Tebrikler! IDapps hesabınız başarıyla oluşturuldu.',
      redirecting: 'Hesabınıza yönlendiriliyorsunuz...'
    },

    form: {
      name: 'Ad Soyad',
      email: 'E-posta Adresi',
      phone: 'Telefon Numarası',
      password: 'Şifre',
      namePlaceholder: 'Ad Soyad',
      emailPlaceholder: 'ornek@mail.com',
      phonePlaceholder: '5XX XXX XX XX',
      continue: 'Devam Et',
      completeRegistration: 'Hesabı Oluştur',
      registering: 'Kaydediliyor...'
    },
    accessibility: {
      hint: 'Yardımcı seçenekler',
      switchToText: 'Yazılı form',
      switchToVoice: 'Sesli mod'
    }
  },

  // Profil bölümü
  profile: {
    personalInfo: 'Kişisel Bilgiler',
    bloodType: 'Kan Grubu',
    height: 'Boy',
    weight: 'Kilo',
    heightWeight: 'Boy / Kilo',
    languages: 'Diller',
    contacts: 'İletişim',
    bio: 'Hakkımda',
    editProfile: 'Profili Düzenle',
    identity: 'Kimlik',
    profileTitle: 'Profil',
    qrId: 'QR Kimliğim',
    tattoo: 'Dövme',
    shareProfileQR: 'Profilinizi paylaşmak için bu QR kodunu gösterin',
    profileLinkCopied: 'Profil paylaşım bağlantısı kopyalandı',
    shareProfileDescription: '{name} profilini paylaşmak için bu QR kodunu kullanabilirsiniz'
  },

  // Güvenlik ve doğrulama
  security: {
    security: 'Güvenlik',
    securityStatus: 'Güvenlik Durumu',
    accountSecure: 'Hesabınız güvende',
    securityMeasuresActive: 'Tüm güvenlik önlemleri etkin durumda.',
    twoFactorAuth: 'İki Faktörlü Doğrulama',
    active: 'Aktif',
    passwordStrength: 'Şifre Gücü',
    strong: 'Güçlü',
    lastLogin: 'Son Giriş',
    today: 'Bugün',
    manageSecuritySettings: 'Güvenlik Ayarlarını Yönet',
    blockchainSecurity: 'Blockchain Güvenliği',
    blockchainSecurityDesc: 'Blockchain cüzdanı bağlantısı ile hesabınız ekstra güvenlikle korunmaktadır.',
    connectedWallet: 'Bağlı Cüzdan',
    securityVerification: 'Güvenlik Doğrulaması',
    biometricAuth: 'Biyometrik Doğrulama',
    setupTwoFA: '2FA Kurulumu',
    scanQRCode: 'QR Kodu Tara',
    enterCode: 'Kodu Gir',
    recoveryKey: 'Kurtarma Anahtarı',
    backupCodes: 'Yedek Kodlar',
    passwordAndSecurity: 'Şifre ve Güvenlik',
    emailAndContact: 'E-posta ve İletişim',
    twoFactorAuthTitle: 'İki Faktörlü Kimlik Doğrulama',
    securitySettings: 'Güvenlik Ayarları',
    endToEndEncryption: 'Uçtan Uca Şifreleme',
    enhancedSecurityMode: 'Gelişmiş güvenlik modu aktif',
    maxSecurityMode: 'Maksimum güvenlik modu aktif',
    endToEndEncryptionAccess: 'Uçtan uca şifrelenmiş güvenli erişim',
    secure: 'Güvenli',
    customQR: 'Özel QR',
    customQRCodes: 'Özel QR Kodları',
    customQRDescription: 'Sık kullandığınız bağlantılar için özel QR kodları oluşturun ve hızlıca paylaşın.',
    noCustomQR: 'Henüz özel QR kodunuz yok.',
    linkName: 'Bağlantı adı',
    addNewQRCode: 'Yeni QR Kodu Ekle',

    // İki Faktörlü Kimlik Doğrulama bölümü
    twoFA: {
      // Sekmeler
      tabs: {
        setup: 'Kurulum',
        codes: 'Kodlar',
        backup: 'Yedekleme',
        devices: 'Cihazlar'
      },

      // Durum mesajları
      status: {
        enabled: '2FA Etkin',
        disabled: '2FA Etkin Değil'
      },

      // Hata mesajları
      errors: {
        walletRequired: '2FA kurulumu için önce blockchain cüzdanınızı bağlamanız gerekiyor.',
        setupFailed: 'Kurulum sırasında bir hata oluştu. Lütfen tekrar deneyin.',
        invalidCode: 'Lütfen 6 haneli doğrulama kodunu girin.',
        verificationFailed: 'Geçersiz doğrulama kodu. Lütfen tekrar deneyin.',
        generalError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
        codeRequired: 'Lütfen güvenlik doğrulama kodunu girin.',
        disableFailed: '2FA devre dışı bırakılamadı. Kod hatalı olabilir.',
        passwordTooShort: 'Lütfen en az 8 karakterli bir şifre girin.',
        exportFailed: '2FA verileri dışa aktarılamadı.',
        noImportData: 'Lütfen içe aktarılacak 2FA verilerini girin.',
        passwordRequired: 'Lütfen şifrenizi girin.',
        importFailed: '2FA verileri içe aktarılamadı. Şifre yanlış olabilir.',
        deviceRemoveFailed: 'Cihaz kaldırılamadı.'
      },

      // Başarı mesajları
      success: {
        verified: 'Doğrulama başarılı! 2FA etkinleştirildi.',
        disabled: '2FA başarıyla devre dışı bırakıldı.',
        exported: '2FA verileri başarıyla dışa aktarıldı.',
        imported: '2FA verileri başarıyla içe aktarıldı.',
        deviceRemoved: 'Cihaz başarıyla kaldırıldı.',
        deviceVerified: 'Cihaz başarıyla doğrulandı.',
        enabled: '2FA Etkinleştirildi!',
        enabledDescription: 'İki faktörlü kimlik doğrulama başarıyla etkinleştirildi. Artık hesabınız daha güvende.'
      },

      // Genel etiketler ve açıklamalar
      decentralized: 'Merkeziyetsiz 2FA',
      description: 'İki faktörlü kimlik doğrulama (2FA), hesabınıza ekstra bir güvenlik katmanı ekler. Bu özellik, şifrenizin ele geçirilmesi durumunda bile hesabınızın korunmasını sağlar.',
      scanQRCode: 'QR Kodu Tarayın',
      scanQRDescription: 'Google Authenticator, Authy veya benzer bir kimlik doğrulama uygulaması kullanarak aşağıdaki QR kodunu tarayın.',
      manualKeyInstructions: 'QR kodu tarayamıyorsanız, bu anahtarı manuel olarak girebilirsiniz:',
      verificationCode: 'Doğrulama Kodu',
      enterSixDigitCode: '6 haneli kodu girin',
      disableInstructions: 'İki faktörlü kimlik doğrulama şu anda etkin. Bu özelliği devre dışı bırakmak için, cihazınızdaki kimlik doğrulama uygulamasından bir doğrulama kodu girin.',
      currentCode: 'Mevcut Kod',
      codeRefreshTime: '{seconds} saniye içinde yenilenecek',
      codeRefreshing: 'Yenileniyor...',
      backupCodes: 'Yedek Kodlar',
      backupCodesInstructions: '2FA cihazınıza erişemediğinizde bu yedek kodları kullanabilirsiniz. Her kod sadece bir kez kullanılabilir.',
      backupCodesDescription: 'Bu yedek kodları güvenli bir yerde saklayın. Kimlik doğrulayıcı uygulamanıza erişemediğinizde bu kodları kullanabilirsiniz.',
      saveBackupCodes: 'Yedek Kodları Saklayın',
      blockchainVerification: 'Blockchain Doğrulama',
      blockchainVerificationDescription: '2FA doğrulama kanıtlarınız blockchain üzerinde güvenli bir şekilde saklanır ve doğrulanır.',
      lastVerification: 'Son Doğrulama',
      timeAgo: '{time} saat önce',
      verifiedOnPolygon: 'Polygon ağı üzerinde doğrulandı',
      proofGenerated: 'Doğrulama kanıtı oluşturuldu: {proof}...',
      enableFirstToViewCodes: 'Doğrulama kodlarını görüntülemek için önce 2FA\'yı etkinleştirmeniz gerekiyor.',
      backupAndRecovery: 'Yedekleme ve Kurtarma',
      backupDescription: '2FA verilerinizi (şifrelenmiş olarak) dışa aktarabilir veya önceden yedeklediğiniz verileri içe aktarabilirsiniz.',
      exportData: 'Verileri Dışa Aktar',
      exportDescription: '2FA verilerinizi güçlü bir şifre ile şifreleyerek dışa aktarın. Bu dosyayı güvenli bir yerde saklayın.',
      password: 'Şifre',
      passwordPlaceholder: 'Şifrenizi girin (en az 8 karakter)',
      encryptedData: 'Şifreli Veriler',
      storeDataSafely: 'Bu verileri güvenli bir şekilde saklayın. Şifrenizi unutursanız, verileri kurtaramazsınız.',
      importData: 'Verileri İçe Aktar',
      importDescription: 'Daha önce dışa aktardığınız 2FA verilerini içe aktarın. Bu işlem mevcut 2FA ayarlarınızı değiştirecektir.',
      pasteEncryptedData: 'Dışa aktarılan şifreli verileri yapıştırın',
      enterPassword: 'Şifrenizi girin',
      arweaveBackup: 'Arweave Yedeklemesi',
      arweaveDescription: '2FA doğrulama kanıtlarınız Arweave üzerinde şifrelenmiş olarak saklanır. Bu, kalıcı ve değiştirilemez bir yedekleme sağlar.',
      arweaveBackupStarted: 'Arweave yedekleme işlemi başlatıldı. Bu işlem birkaç dakika sürebilir.',
      decentralizedStorage: 'Merkeziyetsiz Depolama',
      arweaveTokenRequired: 'Arweave, verilerinizin kalıcı ve değiştirilemez şekilde saklanmasını sağlar. Yedekleme işlemi için bir miktar AR token gereklidir.',
      verifiedDevices: 'Doğrulanmış Cihazlar',
      devicesDescription: '2FA doğrulaması tamamlanmış cihazlarınızı buradan yönetebilirsiniz.',
      noVerifiedDevices: 'Henüz doğrulanmış cihaz bulunmuyor.',
      thisDevice: 'Bu Cihaz',
      deviceVerificationDescription: 'Kullandığınız cihaz otomatik olarak doğrulanmış cihazlar listesine eklenir. Cihazlarınızı düzenli olarak kontrol edin ve tanımadığınız cihazları kaldırın.',
      deviceConnectionHistory: 'Cihaz Bağlantı Geçmişi',
      lastAccess: 'Son erişim: {time}',
      daysAgo: '{days} gün önce',
      weeksAgo: '{weeks} hafta önce',

      // Cihaz tipleri
      deviceTypes: {
        mobile: 'Mobil Cihaz',
        desktop: 'Masaüstü Cihaz'
      },

      // Özellikler bölümü
      features: {
        highSecurity: {
          title: 'Yüksek Güvenlik',
          description: 'Kimlik doğrulama kodları, cihazınızda bulunan gizli bir anahtarla üretilir.'
        },
        easyToUse: {
          title: 'Kolay Kullanım',
          description: 'QR kod taraması ile herhangi bir kimlik doğrulama uygulamasını kullanabilirsiniz.'
        },
        decentralized: {
          title: 'Merkeziyetsiz',
          description: 'Güvenlik verileri blockchain üzerinde doğrulanır, sunuculara bağımlı değildir.'
        }
      },

      // Kurtarma bilgileri modalı
      recoveryInfo: {
        title: 'Kurtarma Bilgileri',
        description: '2FA kurtarma seçenekleri sayesinde cihazınızı kaybetseniz veya uygulamanızı silseniz bile hesabınıza erişebilirsiniz:',
        backupCodes: {
          title: 'Yedek Kodlar',
          description: 'Her bir yedek kod bir kerelik kullanım için geçerlidir. Bu kodları güvenli bir yerde saklayın.'
        },
        encryptedBackup: {
          title: 'Şifreli Yedek',
          description: '2FA verilerinizi şifrelenmiş olarak dışa aktarabilirsiniz. Bu şifreyi unutmayın, aksi takdirde yedek kullanılamaz.'
        },
        verifiedDevices: {
          title: 'Doğrulanmış Cihazlar',
          description: 'Daha önce doğrulanmış cihazlarınız kimlik doğrulama sürecinde size yardımcı olabilir.'
        }
      },

      // Cihaz kaldırma modalı
      removeDevice: {
        title: 'Cihazı Kaldır',
        confirmation: 'Bu cihazı kaldırmak istediğinizden emin misiniz?'
      },

      // Butonlar
      buttons: {
        startingSetup: 'Kurulum Başlatılıyor',
        startSetup: '2FA Kurulumunu Başlat',
        verifying: 'Doğrulanıyor...',
        verify: 'Doğrula',
        disable: '2FA\'yı Devre Dışı Bırak',
        copyCode: 'Kodu Kopyala',
        copyAll: 'Tümünü Kopyala',
        generateNewCodes: 'Yeni Kodlar Üret',
        generateProof: 'Doğrulama Kanıtı Oluştur',
        goToSetup: '2FA Kurulumuna Git',
        export: 'Dışa Aktar',
        import: 'İçe Aktar',
        backupToArweave: 'Arweave\'e Yedekle',
        verifyThisDevice: 'Bu Cihazı Doğrula'
      }
    }
  },

  // Dijital Disiplin bölümü
  digitalDiscipline: {
    panelTitle: 'Dijital Disiplin Paneli',
    panelDescription: 'Dijital alışkanlıklarını kontrol et, hedeflerine ulaş',
    newGoal: 'Yeni Hedef Oluştur',
    noGoals: 'Henüz hedefin yok',
    noGoalsInCategory: 'Bu kategoride hedefin yok',
    createGoal: 'Hedef Oluştur',
    startGoal: 'Başlat',
    cancel: 'İptal',
    save: 'Kaydet',
    title: 'Başlık',
    titlePlaceholder: 'Örn: 1 saat kitap oku',
    category: 'Kategori',
    duration: 'Süre (dakika)',
    earnedXP: 'Kazanılacak XP',
    automaticCalc: 'Süre ve kategoriye göre otomatik hesaplanır',
    totalXP: 'Toplam XP',
    activeTimers: 'Aktif Zamanlayıcılar',
    show: 'Göster',
    hide: 'Gizle',
    // Kategoriler
    all: 'Tümü',
    productivity: 'Üretkenlik',
    health: 'Sağlık',
    digital_detox: 'Dijital Detoks',
    learning: 'Öğrenme',
    other: 'Diğer'
  },

  // Auth Context için çeviriler
  auth: {
    login: {
      inProgress: 'İşlem zaten devam ediyor',
      credentialsRequired: 'Kullanıcı adı ve şifre gereklidir.',
      error: 'Giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.'
    },
    register: {
      inProgress: 'İşlem zaten devam ediyor',
      userDataRequired: 'Geçerli kullanıcı bilgileri gereklidir.',
      error: 'Kayıt işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.'
    },
    resetPassword: {
      inProgress: 'İşlem zaten devam ediyor',
      emailRequired: 'Geçerli bir e-posta adresi gereklidir.',
      success: 'Şifre sıfırlama bağlantısı gönderildi.',
      error: 'Şifre sıfırlama işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.'
    },
    profile: {
      dataRequired: 'Geçerli profil bilgileri gereklidir.',
      updateError: 'Profil güncelleme işlemi sırasında bir hata oluştu.'
    },
    navigation: {
      inProgress: 'Yönlendirme işlemi zaten devam ediyor.',
      invalidScreen: 'Geçersiz ekran adı.',
      redirectError: 'Kimlik doğrulaması sonrası yönlendirme hatası:'
    },
    session: {
      checkError: 'Oturum durumu kontrol edilirken hata oluştu:',
      loadError: 'Oturum bilgileri yüklenirken bir hata oluştu.'
    },
    identity: {
      verificationFailed: 'Kimlik doğrulama başarısız.',
      error: 'Kimlik doğrulama sırasında bir hata oluştu.'
    },
    security: {
      reAuthRequired: 'Güvenli ekranlara erişim için yeniden kimlik doğrulama gerekiyor.',
      authRequired: 'Kimlik doğrulaması olmadan korumalı ekranlara erişilemiyor.'
    },
    wallet: {
      connectError: 'Cüzdan bağlama işlemi sırasında bir hata oluştu.',
      arweaveError: 'Arweave cüzdan bağlama işlemi sırasında bir hata oluştu.',
      walletRequired: 'Arweave işlemleri için wallet bağlantısı gereklidir'
    },
    '2fa': {
      loadError: '2FA verileri otomatik olarak yüklenemedi:',
      walletRequired: '2FA kurulumu için cüzdan bağlantısı gereklidir',
      setupError: '2FA kurulum hatası:',
      notSetup: '2FA henüz kurulmadı',
      verifyError: '2FA doğrulama hatası:',
      disableError: '2FA devre dışı bırakma hatası:',
      getCodeError: '2FA kod alma hatası:',
      exportError: '2FA veri dışa aktarma hatası:',
      importError: '2FA veri içe aktarma hatası:',
      proofError: '2FA kanıt oluşturma hatası:'
    },
    arweave: {
      uploadError: 'Arweave yükleme hatası:',
      downloadError: 'Arweave indirme hatası:',
      listError: 'Arweave işlem listesi hatası:',
      walletRequired: 'Arweave işlemleri için wallet bağlantısı gereklidir'
    },
    notes: {
      saveError: 'Not kaydetme hatası:',
      getError: 'Not alma hatası:'
    }
  },

  // Dijital kasa ve notlar
  vault: {
    vault: 'Kasa',
    notes: 'Notlar',
    backups: 'Yedeklemeler',
    addNote: 'Not Ekle',
    searchNotes: 'Notlarda Ara',
    noteTitle: 'Not Başlığı',
    noteContent: 'Not İçeriği',
    addTag: 'Etiket Ekle',
    saveNote: 'Notu Kaydet',
    digitalVaultTitle: 'Dijital Kasa',
    endlessNotesTitle: 'Sonsuz Notlar',
    memoryPalace: 'Hafıza Sarayı'
  },

  // Uygulama ayarları
  settings: {
    appSettings: 'Uygulama Ayarları',
    appSettingsDesc: 'Uygulama davranışını ve tercihlerinizi yönetin',
    accountSettings: 'Hesap Ayarları',
    accountSettingsDesc: 'Profil bilgilerinizi ve tercihlerinizi yönetin',
    languageSelection: 'Dil Seçimi',
    selectLanguageDescription: 'Uygulamayı kullanmak istediğiniz dili seçin.',
    themeAndAppearance: 'Tema ve Görünüm',
    notificationSettings: 'Bildirim Ayarları',
    languageAndRegion: 'Dil ve Bölge',
    other: 'Diğer',
    helpAndSupport: 'Yardım ve Destek',
    aboutAndLegal: 'Hakkında ve Yasal',
    confirmLogout: 'Çıkış yapmak istiyor musunuz?',
    logoutDescription: 'Hesabınızdan çıkış yapmak üzeresiniz. Tekrar giriş yapmanız gerekecektir.',
    darkMode: 'Karanlık Mod', // Eskiden vardı
    lightMode: 'Aydınlık Mod',  // Eskiden vardı
    switchToLightMode: 'Aydınlık moda geç', // Eklendi
    switchToDarkMode: 'Karanlık moda geç' // Eklendi
  },

  // Hesap bilgileri
  account: {
    title: 'Hesap bilgilerini gir',
    description: 'Hesap oluşturma işlemini tamamlamak için hesap bilgilerini gir.',
    gender: {
      male: 'Erkek',
      female: 'Kadın',
      other: 'Diğer'
    },
    error: {
      missingFields: 'Lütfen tüm gerekli alanları doldurun.',
      passwordMismatch: 'Şifreler eşleşmiyor.',
      passwordTooShort: 'Şifre en az 6 karakter olmalıdır.'
    },
    termsAgreement: 'Hesap oluşturarak {terms} ile {privacy} içeriklerini kabul etmiş olursun.',
    termsAndConditions: 'Şartlar ve Koşullar',
    privacyPolicy: 'Kullanıcı Gizlilik Sözleşmesi'
  },

  // Bildirimler bölümü için çeviriler
  // dashboard bölümü
  dashboard: {
    exhibitions: 'Sergilenenler',
    identity: 'Kimlik',
    myFolders: 'Klasörlerim',
    qrIdentity: 'QR Kimlik',
    badges: 'Rozetler',
    activity: 'Aktivite',
    active: 'Aktif',
    noItems: 'Bu klasörde henüz öğe yok',
    addItem: 'Öğe Ekle',
    folders: {
      personal: 'Kişisel',
      health: 'Sağlık',
      documents: 'Belgeler',
      favorite: 'Favoriler'
    },
    emergencyInfo: 'Acil Durum Bilgileri',
    allergies: 'Alerjiler',
    healthConditions: 'Sağlık Durumu',
    medications: 'İlaçlar',
    emergencyContacts: 'Acil Durum Kişileri',
    addEmergencyContact: 'Acil Durum Kişisi Ekle',
    personalInfo: 'Kişisel Bilgiler'
  },

  // Bildirimler bölümü
  notifications: {
    tabs: {
      incoming: 'Gelen',
      reminders: 'Hatırlatıcılar',
      tasks: 'Görevler'
    },
    markAllAsRead: 'Tümünü Okundu İşaretle',
    new: 'Yeni',
    goToGame: 'Oyuna Git',
    noSearchResults: 'Arama sonucu bulunamadı',
    noNotifications: 'Henüz bildirim yok',
    noReminders: 'Henüz hatırlatıcı yok',
    clearSearch: 'Aramayı Temizle',
    addReminder: 'Hatırlatıcı Ekle',
    loading: 'Bildirimler yükleniyor...',
    reminder: {
      new: 'Yeni Hatırlatıcı',
      title: 'Başlık',
      titlePlaceholder: 'Hatırlatıcı başlığı',
      description: 'Açıklama',
      descriptionPlaceholder: 'Açıklama (isteğe bağlı)',
      date: 'Tarih',
      time: 'Saat',
      category: 'Kategori',
      priority: 'Öncelik',
      repeat: 'Tekrarlama',
      noRepeat: 'Tekrar yok'
    },
    categories: {
      personal: 'Kişisel',
      work: 'İş',
      health: 'Sağlık',
      finance: 'Finans',
      entertainment: 'Eğlence'
    },
    priorities: {
      low: 'Düşük',
      medium: 'Orta',
      high: 'Yüksek'
    },
    repeat: {
      daily: '🔄 Her gün',
      weekly: '🔄 Her hafta',
      monthly: '🔄 Her ay',
      yearly: '🔄 Her yıl'
    },
    filters: {
      all: 'Tümü',
      connections: 'Bağlantılar',
      messages: 'Mesajlar',
      verifications: 'Doğrulamalar',
      security: 'Güvenlik',
      games: 'Oyunlar',
      system: 'Sistem',
      active: 'Aktif',
      completed: 'Tamamlanan',
      highPriority: 'Yüksek Öncelik',
      mediumPriority: 'Orta Öncelik',
      lowPriority: 'Düşük Öncelik'
    },
    time: {
      justNow: 'Az önce',
      minutesAgo: '{minutes} dakika önce',
      hoursAgo: '{hours} saat önce',
      daysAgo: '{days} gün önce',
      today: 'Bugün {time}',
      tomorrow: 'Yarın {time}',
      futureDate: '{date} {time}',
      fullDate: '{day}/{month}/{year}'
    },
    errors: {
      loadFailed: 'Bildirim verilerini yüklerken hata:'
    },
    demo: {
      connectionRequest: 'Bağlantı isteği gönderdi',
      idappsVerification: 'IDapps Doğrulama',
      qrVerified: 'QR kodunuz başarıyla doğrulandı',
      securityCenter: 'Güvenlik Merkezi',
      newLogin: 'Hesabınıza yeni bir cihazdan giriş yapıldı',
      system: 'Sistem',
      appUpdated: 'IDapps uygulaması güncellendi, yeni özellikleri keşfedin',
      sentMessage: 'Size bir mesaj gönderdi: "Merhaba, nasılsın?"',
      gameHub: 'IDapps GameHub',
      newGame: 'Yeni oyun: Kripto Macerası yayında! 50 IDCOIN ödüllü turnuva başladı.',
      connectionAccepted: 'Bağlantı isteğinizi kabul etti',
      reminders: {
        weeklyMeeting: 'Haftalık Toplantı',
        teamMeeting: 'Ekip toplantısı - Zoom üzerinden',
        doctorAppointment: 'Doktor Randevusu',
        dentalCheckup: 'Diş kontrolü - Ankara Diş Hastanesi',
        bills: 'Faturalar',
        utilityBills: 'Elektrik ve su faturası ödemesi',
        birthday: 'Doğum Günü',
        mothersBirthday: 'Annemin doğum günü - Hediye al',
        gameTournament: 'GameHub Turnuvası',
        puzzleTournament: 'IDapps Blockchain Bulmaca Turnuvası'
      }
    },
    tasks: {
      dailyTasks: 'Günlük Görevler',
      wakeUp: 'Sabah 7\'de uyan',
      checkEmails: 'E-postaları kontrol et',
      reviewProject: 'Proje planını gözden geçir',
      completeGameTasks: 'IDapps GameHub\'da günlük görevleri tamamla',
      workSchedule: 'Çalışma Programı',
      projectDevelopment: 'Proje geliştirme',
      meetings: 'Toplantılar',
      codeReviews: 'Kod incelemeleri',
      gameTournament: 'GameHub Turnuvası',
      upcomingEvents: 'Yaklaşan Etkinlikler',
      blockchainMeetup: 'Blockchain Meetup',
      web3Conference: 'Web3 Konferansı',
      onlineEvent: 'Online Etkinlik',
      idappsGameTournament: 'IDapps Oyun Turnuvası',
      metaverseEvent: 'Metaverse Etkinliği',
      goals: 'Hedefler',
      dailyStepGoal: 'Günlük adım hedefi',
      waterIntake: 'Su içme (ml)',
      workTime: 'Çalışma süresi',
      idcoinGoal: 'IDCOIN Hedefi',
      hours: 'saat'
    }
  },

  // Blockchain ve cüzdan bağlantıları
  blockchain: {
    connectWallet: 'Cüzdan Bağla',
    walletConnected: 'Cüzdan Bağlandı',
    walletAddress: 'Cüzdan Adresi',
    arweaveSync: 'Arweave Senkronizasyonu',
    backupToArweave: 'Arweave\'e Yedekle',
    permanentStorage: 'Kalıcı Depolama',
    walletTitle: 'Blockchain Cüzdanı',
    walletDescription: 'Merkeziyetsiz kimliğinizi güvence altına almak için blockchain cüzdanını bağlayabilirsiniz.',
    wallet: 'Cüzdan'
  },

  // Ekran başlıkları
  screens: {
    dashboardTitle: 'Ana Sayfa',
    qrScannerTitle: 'QR Kod Tarayıcı',
    gameHubTitle: 'Oyun Merkezi',
    messagingTitle: 'Mesajlaşma',
    notificationsTitle: 'Bildirimler',
    forgotPasswordTitle: 'Şifremi Unuttum',
    chatsTab: 'Sohbetler',
    groupsTab: 'Gruplar'
  },

  // Mesajlaşma ekranı
  messaging: {
    searchChat: 'Sohbet ara...',
    noSearchResults: 'Arama sonucu bulunamadı',
    noResultsFor: '"{searchQuery}" için sonuç yok',
    noGroupChats: 'Henüz hiç grup sohbeti oluşturmadınız.',
    createNewGroup: 'Yeni Grup Oluştur',
    encryptionDescription: 'IDapps\'teki tüm mesajlarınız uçtan uca şifrelenir ve sadece siz ve mesajlaştığınız kişi tarafından okunabilir.',
    selfDestructMessages: 'Kendini İmha Eden Mesajlar',
    selfDestructDescription: 'Özel konuşmalarınız için kendini imha eden mesajlar gönderin. Okunduğunda otomatik olarak silinirler.',
    activateFeature: 'Özelliği Aktifleştir',
    aiAssistantPrivacy: 'AI Asistan Gizliliği',
    aiPrivacyDescription: 'Mesajlaşma asistanınız tamamen cihazınızda çalışır ve verileriniz hiçbir sunucuya gönderilmez.',
    aiAssistantActive: 'AI Asistanı Aktif',
    aiResponseSuggestions: 'AI Yanıt Önerileri',
    writeMessage: 'Mesaj yazın...',
    online: 'Çevrimiçi',
    lastSeen: 'Son görülme: Bugün 15:42',
    greeting: 'Selam, nasılsın?',
    imGood: 'İyiyim, sen?',
    imGoodToo: 'Ben de iyiyim, teşekkürler.',
    sentToYou: 'Gönderdim sana.',
    canYouSendFiles: 'Dosyaları gönderebilir misin?',
    agreed: 'Anlaştık.',
    projectCostQuestion: 'Merhaba, projenin maliyeti hakkında konuşabilir miyiz?',
    whatDoYouThink: 'Tabii, ne düşünüyorsun?',
    priceProposal: 'Bence 5000₺ uygun bir fiyat.',
    seeYou: 'Tamamdır, görüşürüz.',
    meetingInvite: 'Yarın toplantı saat 15:00\'te, katılabilir misin?',
    callMeWhenFree: 'Müsait olduğunda beni arar mısın?',
    aiSuggestion1: 'Evet, tamamladım. Birazdan göndereceğim.',
    aiSuggestion2: 'Üzerinde çalışıyorum, yarına hazır olacak.',
    aiSuggestion3: 'Henüz bitirmedim, bu hafta içinde tamamlayacağım.',
    aiSuggestion4: 'Tabii, 10 dakika içinde arıyorum.',
    aiSuggestion5: 'Şu an toplantıdayım, 1 saat sonra arayabilir miyim?',
    aiSuggestion6: 'Bugün müsait değilim, yarın arasam olur mu?'
  },

  // GameHub bölümü için çeviriler
  gameHub: {
    loadingGames: 'Oyunlar yükleniyor...',
    play: 'Oyna',
    join: 'Katıl',
    progress: 'İlerleme',
    level: 'Seviye {completed}/{total}',
    rewards: 'Ödüller',
    points: 'puan',
    totalPoints: 'Toplam Puan',
    xpProgress: 'XP: {current}/{next}',
    featuredGame: 'Öne Çıkan Oyun',
    categoriesTitle: 'Kategoriler',
    allGames: 'Tüm Oyunlar',
    seeAll: 'Tümünü Gör',
    dailyLogin: 'Günlük Giriş',
    dayStreak: '{days} Gün Seri',
    dailyLoginInfo: 'Her gün giriş yaparak IDCOIN kazanabilirsin. 7 gün üst üste giriş yaptığında bonus ödül!',
    completed: '{completed}/{total} Tamamlandı',
    playerCount: '{count} Oyuncu',
    coinReward: '{amount} IDCOIN Ödül',
    participants: 'Katılımcı: {count}',
    startingGame: '{title} oyunu başlatılıyor...',

    errors: {
      loadFailed: 'GameHub verilerini yüklerken hata:'
    },

    tabs: {
      games: 'Oyunlar',
      daily: 'Günlük',
      leaderboard: 'Sıralama',
      rewards: 'Ödüller'
    },

    categories: {
      quiz: 'Quiz',
      puzzle: 'Bulmaca',
      collection: 'Koleksiyon',
      simulation: 'Simülasyon',
      strategy: 'Strateji'
    },

    games: {
      cryptoQuest: {
        title: 'Kripto Macerası',
        description: 'Kripto para dünyasında ilerle, bilgini test et ve IDCOIN kazan!'
      },
      blockchainPuzzle: {
        title: 'Blockchain Bulmaca',
        description: 'Blockchain üzerine bulmacaları çöz, akıllı sözleşmeleri tamamla!'
      },
      nftCollector: {
        title: 'NFT Koleksiyoncusu',
        description: 'Nadir NFT\'leri topla, koleksiyonunu tamamla ve ödüller kazan!'
      },
      defiTrader: {
        title: 'DeFi Trader',
        description: 'Sanal fonlarla DeFi işlemleri yap, en iyi stratejiyi geliştir!'
      },
      daoManager: {
        title: 'DAO Yöneticisi',
        description: 'DAO\'nu yönet, topluluğu büyüt, doğru kararları ver!'
      }
    },

    dailyTasks: {
      title: 'Günlük Görevler',
      completeAll: 'Tüm görevleri tamamla, bonus kazan!',
      completeAllBonus: 'Günlük tüm görevleri tamamladığında ekstra {coins} IDCOIN bonus ödülü alırsın.',
      completeCryptoQuestLevels: 'Kripto Macerası\'nda 3 seviye tamamla',
      solveBlockchainPuzzle: 'Blockchain Bulmaca\'da bir bulmaca çöz',
      joinCryptoQuestTournament: 'Kripto Macerası turnuvasına katıl',
      collectDailyIdcoin: 'Günlük IDCOIN ödülünü topla',
      inviteFriend: 'Bir arkadaşını GameHub\'a davet et'
    },

    tournament: {
      active: 'Aktif Turnuva',
      activeTournaments: 'Aktif Turnuvalar',
      ended: 'Sona erdi',
      daysHoursLeft: '{days} gün {hours} saat kaldı',
      hoursMinutesLeft: '{hours} saat {minutes} dakika kaldı',
      short: 'Turnuva',
      joinAndWin: 'Turnuvaya katıl ve {coins} IDCOIN kazanma şansı yakala!',
      gameTournament: '{game} Turnuvası'
    },

    leaderboard: {
      yourRank: 'Senin Sıralaması',
      rankPosition: '{rank}. Sıra',
      topPercentage: 'En iyi %{percent} içindesin!',
      weekly: 'Haftalık',
      allTime: 'Tüm Zamanlar',
      seeFullList: 'Tam Listeyi Gör',
      gameLeaderboards: 'Oyun Sıralamaları',
      you: 'Sen'
    },

    rewards: {
      balance: 'Bakiye',
      transfer: 'Transfer',
      transactions: 'İşlemler',
      shop: 'Ödül Mağazası',
      cost: '{amount} IDCOIN',
      daily: 'Günlük',
      completion: 'Tamamlama',
      tournament: 'Turnuva',

      items: {
        premium: {
          title: '1 Ay Premium',
          description: 'Reklamsız deneyim ve ekstra özellikler'
        },
        nft: {
          title: 'NFT Öğe',
          description: 'Özel avatarlar ve dijital eşyalar'
        },
        xpBoost: {
          title: 'XP Boost',
          description: '3 gün boyunca 2x deneyim puanı'
        },
        cryptoGift: {
          title: 'Kripto Hediye',
          description: 'Gerçek kripto para hediye çeki'
        }
      }
    },

    achievements: {
      title: 'Başarılar',
      completed: 'Tamamlandı',
      seeAll: 'Tüm Başarıları Gör',

      firstGame: 'İlk Oyun',
      firstGameDesc: 'İlk oyununu oyna',
      firstTournament: 'İlk Turnuva',
      firstTournamentDesc: 'Bir turnuvaya katıl',
      gameMaster: 'Oyun Ustası',
      gameMasterDesc: '5 farklı oyun oyna',
      collector: 'Koleksiyoncu',
      collectorDesc: '10 başarı rozeti kazan'
    }
  },

  // WelcomeScreen için özel çeviriler
  welcomeScreen: {
    switchToLightMode: 'Aydınlık moda geç',
    switchToDarkMode: 'Karanlık moda geç',
    secureAuthentication: 'Güvenli kimlik doğrulama',
    quickLoginTip: 'Hesabınıza erişin', // Eklendi
    createAccountTip: 'Merkeziyetsiz kimlik devrimine katılın' // Eklendi
  },

  // IdentityFeed çevirileri
  identityCircle: {
    feed: {
      // Create options
      mediaShare: 'Medya Paylaş',
      mediaDescription: 'Fotoğraf, video ve anlar',
      thoughtShare: 'Düşünce Paylaş',
      thoughtDescription: 'Fikirler ve düşünceler',
      voiceNote: 'Sesli Not',
      voiceDescription: 'Sesli mesajlar ve hikayeler',
      statsShare: 'İstatistik Paylaş',
      statsDescription: 'Başarılar ve metrikler',
      digitalVault: 'Dijital Kasa',
      vaultDescription: 'Özel ve şifrelenmiş depolama',

      // Privacy options
      privacyTitle: 'Gizlilik Ayarları',
      privacyDescription: 'İçeriğini kimler görebilsin?',
      circle: 'Circle',
      circleDescription: 'Tüm circle üyelerine görünür',
      closeCircle: 'Yakın Circle',
      closeDescription: 'Sadece yakın arkadaşların görebilir',
      selectedPeople: 'Seçili Kişiler',
      selectedDescription: 'Belirlediğin kişiler görebilir',
      vaultPrivacy: 'Dijital Kasa',
      vaultPrivacyDescription: 'Sadece sen, şifrelenmiş',

      // Post actions
      like: 'Beğen',
      comment: 'Yorum',
      share: 'Paylaş',
      bookmark: 'Kaydet',
      commentPlaceholder: 'Yorum yaz...',
      you: 'Sen',

      // Create modal
      createTitle: 'İçerik Oluştur',
      createDescription: 'Düşüncelerini dünya ile paylaş',
      createPlaceholder: 'Ne düşünüyorsun?',

      // Profile modal
      level: 'Seviye',
      xpProgress: 'XP İlerlemesi',
      compatibility: 'uyumluluk',
      message: 'Mesaj',
      profile: 'Profil',
      mute: 'Sessize Al',
      recentActivity: 'Son Aktiviteler',
      mutualConnections: 'Ortak Bağlantılar',
      more: 'daha',
      swipeToClose: 'Kapatmak için aşağı kaydır',

      // General
      close: 'Kapat',
      cancel: 'İptal',
      confirm: 'Onayla',
      continue: 'Devam',
      ago: 'önce',
      justNow: 'şimdi',
      voiceNoteLabel: 'Sesli Not',
      lastSeen: 'Son görülme bilinmiyor',

      // Share modal
      sharePostTitle: 'Gönderiyi Paylaş',
      sharePostDescription: 'Bu harika içeriği circle\'ın ile paylaş',

      // Statistics sharing
      shareStatsReady: 'istatistik seçildi, paylaşmaya hazır!',
      shareStatsButton: 'İstatistikleri Paylaş',
      selectStatsToShare: 'Paylaşmak istediğin istatistikleri seç',
      sharing: 'Paylaşılıyor...',
      sharingProgress: 'İlerleme raporumu paylaşıyorum! 📈',
      statisticsReport: 'İstatistik Raporu',

      // Statistics categories
      generalLevelXP: 'Genel Seviye ve XP',
      basicStatistics: 'Temel İstatistikler',

      // Metric names
      generalLevel: 'Genel Seviye',
      generalXP: 'Genel XP',
      averageSleep: 'Ortalama Uyku',
      dailySteps: 'Günlük Adım',
      focusTime: 'Odaklanma Süresi',
      completedTasks: 'Tamamlanan Görev',
      activeDays: 'Aktif Gün',
      totalTasks: 'Toplam Görev',
      earnedBadges: 'Kazanılan Rozet',
      currentStreak: 'Mevcut Seri',
      completedGoals: 'Tamamlanan Hedef',

      // Units
      hours: 'saat',
      minutes: 'dk',
      days: 'gün',
      badges: 'rozet',
      goals: 'hedef',

      // Achievement titles
      morningRunAchievement: 'Sabah Koşusu Başarımı',
      achievements: 'Başarımlar',

      // Additional categories
      qrStatistics: 'QR İstatistikleri',
      scansPerformed: 'Yapılan Tarama',
      successfulConnections: 'Başarılı Bağlantı',
      qrCodesGenerated: 'Oluşturulan QR Kod',
      totalQR: 'Toplam QR',
      qrViews: 'QR Görüntüleme',
      health: 'Sağlık',
      productivity: 'Üretkenlik',

      // Time-based metrics
      weeks: 'hafta',
      months: 'ay',
      scans: 'tarama',
      connections: 'bağlantı',
      codes: 'kod',
      qrStatistics: 'QR İstatistikleri',
      totalQR: 'Toplam QR',
      qrViews: 'QR Görüntüleme',
      health: 'Sağlık'
    }
  }
};